import hooks from './shipper.hooks';
import createSchema from './shipper.schema';

export default (app) => {
  const service = app.service('api/shipper');
  service.schema = createSchema(app);
  service.hooks(hooks);
};
